import React from 'react';
import { WalletIcon, ChevronRightIcon, CalendarIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function BalanceSnapshotWidget() {
  const navigate = useNavigate();
  const balanceData = {
    availableBalance: 61767.25,
    upcomingPayout: 45230.8,
    currency: 'THB',
    lastUpdated: '4 Dec 2025 at 1:38 am SGT',
    payoutDate: '5 Dec 2025'
  };
  const formatCurrency = (amount: number) => {
    return `THB ${new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount)}`;
  };
  return <div onClick={() => navigate('/balance')} className="bg-white rounded-lg border border-gray-200 overflow-hidden cursor-pointer hover:border-gray-300 transition-colors flex flex-col h-full" data-id="element-2432">
      {/* Header */}
      <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between bg-white" data-id="element-2433">
        <h3 className="text-sm font-semibold text-gray-900 flex items-center" data-id="element-2434">
          <WalletIcon size={16} className="mr-2 text-green-600" data-id="element-2435" />
          Available balance
        </h3>
        <button onClick={e => {
        e.stopPropagation();
        navigate('/balance');
      }} className="text-xs text-blue-600 hover:text-blue-700 font-medium flex items-center" data-id="element-2436">
          View all
          <ChevronRightIcon size={14} className="ml-1" data-id="element-2437" />
        </button>
      </div>

      {/* Body */}
      <div className="px-4 py-3 bg-white flex-1" data-id="element-2438">
        <p className="text-xs text-gray-500 mb-1" data-id="element-2439">
          Updated on {balanceData.lastUpdated}
        </p>
        <div className="text-2xl font-bold text-gray-900" data-id="element-2440">
          {formatCurrency(balanceData.availableBalance)}
        </div>
      </div>

      {/* Footer */}
      <div className="bg-[#FFF7ED] px-4 py-3 rounded-b-lg flex items-center justify-between h-12" data-id="element-2441">
        <div className="flex items-center gap-1.5 min-w-0" data-id="element-2442">
          <CalendarIcon size={14} className="text-[#F7941D] flex-shrink-0" data-id="element-2443" />
          <span className="text-xs font-medium text-[#92400E] truncate" data-id="element-2444">
            Upcoming payout · {formatCurrency(balanceData.upcomingPayout)} ·{' '}
            {balanceData.payoutDate}
          </span>
        </div>
        <button onClick={e => {
        e.stopPropagation();
        navigate('/payouts');
      }} className="text-xs text-[#F7941D] hover:text-[#D97B06] font-semibold flex items-center flex-shrink-0 ml-3" data-id="element-2445">
          View payout details
          <ChevronRightIcon size={14} className="ml-1" data-id="element-2446" />
        </button>
      </div>
    </div>;
}